import { mapState } from 'vuex';
import axios from 'axios';

const props = {
};

const computed = {
  ...mapState({
    user: state => state.user,
    driverData: state => state.driverData,
    driversResponses: state => state.driversResponses,
    driversHeatmap: state => state.driversHeatmap,
    driversDemographic: state => state.driversDemographic,
    updateDriversFilters: state => state.updateDriversFilters
  })
};

const methods = {
  getSubDriverAnalysis (subdriver) {
    this.isViewLoading = true;
    const filters = Object.assign({}, this.updateDriversFilters);
    if (filters && filters.filters) {
      // filters.filters have the dynamic filters value
      delete filters.filters;
    }
    const queryParams = {
      sub_driver: subdriver,
      driver: this.activeDriver,
      // fields: 'engagement_stats,response_stats,response_list',
      fields: 'engagement_stats,response_stats,demographic_wise_score,milestone_wise_analysis,engagement_heatmap',
      responses_count: true,
      ...filters
    };
    if (this.updateDriversFilters && this.updateDriversFilters.filters) {
      this.$lodash.each(this.updateDriversFilters.filters, (v, k) => {
        if (v.length > 0 && k !== 'session__stage__title') {
          queryParams[`user__profile__${k}__in`] = v.join();
        } else {
          queryParams.stage__title__in = v.join();
        }
      });
    }
    axios.get(`${process.env.VUE_APP_API_URL}driver/${this.activeDriver}/details`, {
      params: queryParams
    }).then((response) => {
      if (response.status === 200) {
        this.$store.dispatch('driverData', response.data);
        this.$store.dispatch('driversHeatmap', {});
        this.$store.dispatch('driversDemographic', []);
        // if (response.data && response.data.interaction_responses) {
        //   this.$store.dispatch('driversResponses', response.data.interaction_responses);
        // }
        if (response.data.engagement_heatmap && response.data.engagement_heatmap_headers) {
          const t = {
            engagement_heatmap: response.data.engagement_heatmap,
            engagement_heatmap_headers: response.data.engagement_heatmap_headers
          };
          this.$store.dispatch('driversHeatmap', t);
        }
        if (response.data.demographic_wise_score) {
          const chartData = [];
          this.$store.dispatch('driversDemographic', chartData);
        }
        if (response.data && response.data.demographic_wise_score && response.data.demographic_wise_score.value) {
          const chartData = [];
          this.$store.dispatch('driversDemographic', {});
          this.$lodash.each(response.data.demographic_wise_score.value, (val, key) => {
            const t = {};
            t.key = key;
            t.value = val;
            chartData.push(t);
          });
          this.$store.dispatch('driversDemographic', chartData);
        }
        this.$nextTick(() => {
          this.isViewLoading = false;
        });
      } else {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Unable to fetch details, Please try again later!'
        });
        throw new Error(response);
      }
    }).catch((err) => {
      if (err.response.status === 429) {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: err.response.data.error
        });
      } else {
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Unable to fetch details filter, Please try again later!'
        });
      }
    });
  }
};

export default {
  props,
  computed,
  methods
};
